export function getPracticePoolWarningLevel(counts) {
  if (!counts || !Number.isFinite(counts.practicing) || !Number.isFinite(counts.testing)) return 0;
  const practicing = Math.max(0, counts.practicing);
  const remaining = practicing + Math.max(0, counts.testing);
  if (remaining === 0) return 3;
  if (remaining < 80) return 2;
  if (practicing < 80) return 1;
  return 0;
}
